'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-result.routes';

export class SurveyResultComponent {
  constructor(Auth, SurveysService, SurveyResultsService, dialogs, $uibModal, $stateParams, $scope) {
    'ngInject';

    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;
    this.$scope = $scope;

    this.model = {};
    this.surveyId = $stateParams.id;

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.chartData = [];
    this.chartLabel = [];

    this.responses = [];

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.SurveysService.get({id: this.surveyId}, (survey) => {
      this.survey = survey;

      for (let i=0; i<survey.questions.length; i++) {
        let key = "question_"+i;

        this.responses[key] = [];

        switch (survey.questions[i].type) {
          case 'text':
            break;
          case 'select-one':
          case 'select-many':
            survey.questions[i].answers.forEach(answer => {
              this.responses[key].push({answer: answer, count: 0})
            });
            break;
        }

      }

      this.SurveyResultsService.getResultsBySurvey({survey: this.surveyId}, results => {
        results.forEach(result => {
          for (let i=0; i<survey.questions.length; i++) {
            let key = "question_" + i;

            switch (survey.questions[i].type) {
              case 'text':
                let idx1 = this.responses[key].findIndex(elm => elm.answer == result.answers[key]);
                if (idx1 !== -1) {
                  this.responses[key][idx1].count++;
                } else {
                  this.responses[key].push({answer: result.answers[key], count: 1});
                }
                break;
              case 'select-one':
                let idx = this.responses[key].findIndex(elm => elm.answer == result.answers[key]);
                this.responses[key][idx].count++;
                break;
              case 'select-many':
                result.answers[key].forEach(answer => {
                  let idx = this.responses[key].findIndex(elm => elm.answer == answer);
                  this.responses[key][idx].count++;
                });
                break;
            }
          }
        });

        for (let i=0; i<survey.questions.length; i++) {
          let key = "question_" + i;

          let answers = this.responses[key];

          this.chartData[i] = [];
          this.chartLabel[i] = [];

          answers.forEach(answer => {
            this.chartData[i].push(answer.count);
            this.chartLabel[i].push(answer.answer);
          });
        }

        console.log(this.chartData);
        console.log(this.chartLabel);

      });

    }, err => {
      console.log("Could not retrieve survey results from server.")
    })
  }

}

export default angular.module('conduu.surveyResult', [uiRouter])
  .config(routes)
  .component('surveyResult', {
    template: require('./survey-result.html'),
    controller: SurveyResultComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/result/survey-result.component.js